import React from 'react';
import { FaEnvelope, FaMapMarkerAlt, FaGraduationCap, FaBriefcase, FaAward, FaTools } from 'react-icons/fa';
const profileImage = "/other-images/profile-image.png";

const About: React.FC = () => {
  const aboutBackgroundImage = "/work-images/uvod3.png";
  
  return (
    <div 
      className="about-page"
      style={{ '--about-bg-image': `url(${aboutBackgroundImage})` } as React.CSSProperties}
    >
      <div className="cv-container">
        {/* Header Section */}
        <div className="cv-header fadeUpStart">
          <div className="profile-section fadeUp">
            <div className="profile-image">
              <img src={profileImage} alt="Ing. arch. Dorota Świderová" />
            </div>
            <div className="profile-info fadeUp">
              <h1 className="profile-name">Ing. arch. Dorota Świderová</h1>
              <h2 className="profile-title">Architektka</h2>
              <p className="profile-summary">
              Mým cílem je čistá, promyšlená architektura, která dává smysl. Věřím, že i ten nejmenší detail utváří celek. 
              </p>
            </div>
          </div>
          
          <div className="contact-section">
            <h3>Kontakt</h3>
            <div className="contact-item">
              <FaEnvelope />
              <span>swiderova@archibim.cz</span>
            </div>
            {/* <div className="contact-item">
              <FaPhone />
              <span>+420 123 456 789</span>
            </div> */}
            <div className="contact-item">
              <FaMapMarkerAlt />
              <span>Havířov, Česká republika</span>
            </div>
            {/* <div className="contact-item">
              <FaLinkedin />
              <span>linkedin.com/in/johndoe</span>
            </div> */}
          </div>
        </div>

        <div className="cv-content fadeUpStart">
          <section className="cv-section">
            <h3 className="section-title fadeUp">
              <FaGraduationCap />
              Vzdělání
            </h3>
            <div className="timeline fadeUp">
              <div className="timeline-item fadeUp">
                {/* <div className="timeline-date">2022 - 2024</div> */}
                <div className="timeline-content">
                  <h4>Magisterské studium</h4>
                  <p className="institution">VŠB-Technická Univerzita Ostrava</p>
                  <p className="description">
                    Fakulta stavební, obor Architektura a stavitelství. Diplomová práce: "Návrh základní školy".
                  </p>
                </div>
              </div>
              <div className="timeline-item fadeUp">
                {/* <div className="timeline-date">2018 - 2022</div> */}
                <div className="timeline-content">
                  <h4>Bakalářské studium</h4>
                  <p className="institution">Vysoké učení technické v Brně</p>
                  <p className="description">
                    Fakulta stavební, obor Architektura pozemních staveb. 
                    Bakalářská práce: "Návrh Autocentra v Mikulově".
                  </p>
                </div>
              </div>
            </div>
          </section>
          <section className="cv-section">
            <h3 className="section-title fadeUp">
              <FaBriefcase />
              Pracovní zkušenosti
            </h3>
            <div className="timeline fadeUp">
              <div className="timeline-item fadeUp">
                <div className="timeline-date">2024 - současnost</div>
                <div className="timeline-content">
                  <h4>Architektka</h4>
                  <p className="institution">ArchiBIM studio</p>
                  <p className="description">
                  Architektonické a urbanistické studie, návrh interiérů, vizualizace, 3D modelování, projekční čínnost,..
                  </p>
                  {/* <ul className="achievements">
                    <li>CEVYKO interiéry</li>
                  </ul> */}
                </div>
              </div>
              <div className="timeline-item fadeUp">
                {/* <div className="timeline-date">2022 - 2023</div> */}
                <div className="timeline-content">
                  <h4>Praxe</h4>
                  <p className="institution">FRIS architekti</p>
                  <p className="description">
                    Návrh interiéru rodinných domů a prodejny v Českém Těšíně,..
                  </p>
                  {/* <ul className="achievements">
                    <li>Realizace projektu CEVYKO</li>
                    <li>Navrh jaksich odpadu dlo prazakow</li>
                  </ul> */}
                </div>
              </div>
            </div>
          </section>
          <section className="cv-section">
            <h3 className="section-title fadeUp">
              <FaTools />
              Dovednosti
            </h3>
            <div className="skills-grid">
              <div className="skill-category">
                <h4 className="fadeUp">Software</h4>
                <ul>
                  <li className="fadeUp">ArchiCAD</li>
                  <li className="fadeUp">Lumion</li>
                  <li className="fadeUp">AutoCAD</li>
                  <li className="fadeUp">SketchUp</li>
                  <li className="fadeUp">Adobe Photoshop</li>
                  <li className="fadeUp">Affinity Designer</li>
                  <li className="fadeUp">MS Office</li>
                </ul>
              </div>
              <div className="skill-category">
                <h4 className="fadeUp">Specializace</h4>
                <ul>
                  <li className="fadeUp">Architektura a urbanismus</li>
                  <li className="fadeUp">Interiérový design</li>
                  <li className="fadeUp">Vizualizace a 3D modelování</li>
                  <li className="fadeUp">Projekční činnost</li>
                </ul>
              </div>
              <div className="skill-category">
                <h4 className="fadeUp">Jazyky</h4>
                <ul>
                  <li className="fadeUp">Čeština (rodný)</li>
                  <li className="fadeUp">Polština (rodný)</li>
                  <li className="fadeUp">Angličtina (střední)</li>
                </ul>
              </div>
            </div>
          </section>
          <section className="cv-section">
            <h3 className="section-title fadeUp">
              <FaAward />
              Ocenění
            </h3>
            <div className="achievements-grid">
              <div className="achievement-item fadeUp">
                <h4>Cena veřejnosti v soutěži Stavby s vůní dřeva</h4>
                <p>Návrh kaple v Pozořici</p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default About;